(function () {
  "use strict";

  class TestimonialsCarousel {
    constructor(carousel) {
      this.carousel = carousel;
      this.track = carousel.querySelector(".testimonials-track");
      this.cards = Array.from(carousel.querySelectorAll(".testimonial-card"));
      this.prevButton = carousel.querySelector(".testimonials-navigation .prev");
      this.nextButton = carousel.querySelector(".testimonials-navigation .next");
      this.dots = Array.from(carousel.querySelectorAll(".testimonials-dots .dot"));
      this.index = 0;
      if (!this.track || !this.cards.length) return;
      this.bindEvents();
      this.setupReadMore();
      this.update(false);
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => {
          this.setupReadMore();
          this.update(false);
        });
      }
    }

    maxOffset() {
      return Math.max(0, this.track.scrollWidth - this.carousel.clientWidth);
    }

    offsetFor(index) {
      const first = this.cards[0];
      const card = this.cards[index];
      return Math.min(this.maxOffset(), Math.max(0, card.offsetLeft - first.offsetLeft));
    }

    update(animate = true) {
      this.index = Math.max(0, Math.min(this.index, this.cards.length - 1));
      const offset = this.offsetFor(this.index);
      this.track.style.transition = animate ? "transform 0.3s ease" : "none";
      this.track.style.transform = `translateX(-${offset}px)`;
      if (this.prevButton) this.prevButton.disabled = offset <= 1;
      if (this.nextButton) this.nextButton.disabled = offset >= this.maxOffset() - 1;
      this.dots.forEach((dot, i) => dot.classList.toggle("active", i === this.index));
    }

    setupReadMore() {
      this.cards.forEach((card) => {
        const content = card.querySelector(".testimonial-content");
        const button = card.querySelector(".testimonial-read-more");
        if (!content || !button) return;
        if (!button.dataset.bound) {
          button.addEventListener("click", () => {
            const expanded = content.classList.toggle("is-expanded");
            button.setAttribute("aria-expanded", String(expanded));
            button.textContent = expanded ? "Read less" : "Read more";
            this.update(false);
          });
          button.dataset.bound = "true";
        }
        if (content.classList.contains("is-expanded")) return;
        button.hidden = content.scrollHeight <= content.clientHeight + 1;
      });
    }

    bindEvents() {
      this.prevButton?.addEventListener("click", () => {
        if (this.index > 0) {
          this.index--;
          this.update();
        }
      });
      this.nextButton?.addEventListener("click", () => {
        if (this.index < this.cards.length - 1) {
          this.index++;
          this.update();
        }
      });
      this.dots.forEach((dot, index) => {
        dot.addEventListener("click", () => {
          this.index = index;
          this.update();
        });
      });
      let startX = 0;
      let startY = 0;
      this.track.addEventListener("touchstart", (event) => {
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
      }, { passive: true });
      this.track.addEventListener("touchend", (event) => {
        const deltaX = event.changedTouches[0].clientX - startX;
        const deltaY = event.changedTouches[0].clientY - startY;
        if (Math.abs(deltaX) < 45 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
        this.index += deltaX < 0 ? 1 : -1;
        this.update();
      }, { passive: true });
      window.addEventListener("resize", () => {
        this.setupReadMore();
        this.update(false);
      });
    }
  }

  function init(container) {
    if (!container || container.dataset.carouselInitialized === "true") return;
    container.dataset.carouselInitialized = "true";
    new TestimonialsCarousel(container);
  }

  function initAll() {
    document.querySelectorAll('[id^="testimonials-"]').forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
  document.addEventListener("shopify:section:load", (event) => {
    const container = event.target.querySelector('[id^="testimonials-"]');
    init(container);
  });
})();
